import { render } from "./carruselultimo.vue?vue&type=template&id=b56e7652&scoped=true"
import script from "./carruselultimo.vue?vue&type=script&lang=js"
export * from "./carruselultimo.vue?vue&type=script&lang=js"

import "./carruselultimo.vue?vue&type=style&index=0&id=b56e7652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56e7652"]])

export default __exports__